import React from 'react';
import DocumentCard from './DocumentCard';

/**
 * Vertical list of artifact cards. Renders nothing when artifacts is empty
 * so callers can mount this unconditionally below the assistant message.
 *
 * @param {object} props
 * @param {Array<import('./DocumentCard').SandboxArtifact>} props.artifacts
 * @param {string|null} props.activeId
 * @param {function(string): void} props.onSelect - called with artifact id
 * @param {function(import('./DocumentCard').SandboxArtifact, Event): void} [props.onDownload]
 *   Optional authenticated download handler forwarded to each DocumentCard.
 */
const DocumentList = ({ artifacts, activeId, onSelect, onDownload }) => {
  if (!artifacts || artifacts.length === 0) return null;
  return (
    <div className="mt-3 space-y-2 w-full max-w-[1200px]">
      <div className="text-xs uppercase tracking-wide text-[var(--app-text-secondary)] px-1">
        Attachments
      </div>
      {artifacts.map((a) => (
        <DocumentCard
          key={a.id}
          artifact={a}
          isActive={a.id === activeId}
          onSelect={onSelect}
          onDownload={onDownload}
        />
      ))}
    </div>
  );
};

export default DocumentList;
